<template>
    <tr :class="[{'clickable': $_loggedUser_action_allowed('subscribers', 'read')}]" @click="showSubscriberProfileDetail(profile.id)">
        <td class="no_padding drag_drop"><span></span></td>
        <td class="no_padding">
          <input type="checkbox"
                 :id="'profCheckbox'+profile.id"
                 :value="profile.id"
                 @change="onChange"
                 :checked="isChecked"
                 @click.stop
          />
          <label :for="'profCheckbox'+profile.id" @click.stop v-translate>Vybrat</label>
        </td>
        <td class="first_data" data-th="Název"><strong>{{ profile.name }}</strong></td>
        <td :data-th="'Profilový obrázek' | translate" class="image">
          <img class="round-image" :src="profile.image_path">
        </td>
        <td data-th="Dětský profil">
          <img
              class="is_set"
              src="../../../../assets/images/is-set.svg"
              :alt="'Ano' | translate"
              v-if="profile.is_child">
        </td>
        <td data-th="Věkový limit">{{ ageLimitText }}</td>
        <td data-th="Přístup s PINem">
          <img
            class="is_set"
            src="../../../../assets/images/is-set.svg"
            :alt="'Ano' | translate"
            v-if="profile.security.access_with_pin">
        </td>
      <td data-th="Editace s PINem">
        <img
            class="is_set"
            src="../../../../assets/images/is-set.svg"
            :alt="'Ano' | translate"
            v-if="profile.security.edit_with_pin">
      </td>
       <td data-th="Naposledy použito" v-html="$_date_formatFull(profile.timestamp_last_used)"></td>
       <td data-th="Poslední zařízení">
         <entity-link v-if="profile.device_name_last_used" :id="profile.id_device_last_used" type="device">{{ profile.device_name_last_used }}</entity-link>
       </td>
        <td data-th="Vytvořeno" v-html="$_date_formatFull(profile.timestamp_created)"></td>
        <td class="no_padding edit">
            <div class="edit_inner">
                <a v-if="isDeletable" class="btn btn_action btn_delete" @click.stop="onDeleteProfile" :title="$gettext('Smazat')">{{ $gettext('Smazat') }}</a>
            </div>
        </td>
    </tr>
</template>

<script>
import EntityLink from "../../../common/EntityLink.vue";
import links from "../../../mixins/links";

export default {
		name: "ProfileRow",
    components: { EntityLink },
    mixins: [links],
		props: {
			profile: Object,
      selectedEntities: Array,
      isDeletable: Boolean,
      idSubscriber: Number,
		},
        methods: {
            onDeleteProfile() {
                this.$emit('deleteProfile', this.profile.id);
            },
          onChange: function (e) {
            this.$emit('input', e)
          },
        },
        computed: {
          isChecked() {
            return this.selectedEntities.indexOf(String(this.profile.id)) > -1
          },
          ageLimitText(){
            if(this.profile.age_limit === 'Všechny věkové kategorie'){
              return this.$gettext('Všechny věkové kategorie');
            }else{
              return this.profile.age_limit
            }
          }
        }
    }

</script>

<style>
.round-image {
  border-radius: 50% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/views/subscribers/profiles/ProfileRow.vue